export enum SocialLink {
  Facebook = "https://www.facebook.com/onlygood.world/",
  Youtube = "https://www.youtube.com/@onlygoodai",
  Instagram = "https://www.instagram.com/onlygood.ai/",
  LinkedIn = "https://www.linkedin.com/company/onlygood-futuretech-india-pvt-ltd-ogfpl/mycompany/verification/",
}

export const OrganizationName: string = "Onlygood";
export const FooterMissionStatement: string =
  "Helping organisations measure their corporate and product impact using primary supply chain data";
export const OgEmailAddress: string = "insight@onlygood.world";
